<div id="root" appCopy>
  @if (loginDisplay) {
  <app-layout></app-layout>
  } @else {
  <app-loader [backdrop]="true"></app-loader>
  }
</div>